import { useForm } from "react-hook-form"
// components
import {
  AddressDetails,
  PersonalDetails,
  DoctorInfo,
  ContactDetails,
} from "./UserDetailsForms"
import { FormNav } from "../Common/Nav"
import { FormWrapper } from "@components/Form"
// hooks
import useAuth from "@hooks/useAuth"

export const SignUpForm = ({ formSteps, updateFormSteps }) => {
  const { handleSignUp } = useAuth()

  // react hook form
  // there is no property name state
  const {
    control,
    watch,
    formState: { errors },
    setValue,
    handleSubmit,
  } = useForm({
    defaultValues: {
      firstName: "",
      lastName: "",
      gender: "",
      contact: "",
      email: "",
      password: "",
      repeatPassword: "",
      country: "",
      province: "",
      pincode: "",
      address: "",
      instituteName: "",
    },
  })

  // handler
  const onSubmit = (data) => {
    if (formSteps === 4) {
      handleSignUp({
        ...data,
        requestType: "Doctor",
      })
    } else {
      updateFormSteps(formSteps + 1)
    }
  }

  // form steps
  const formStepComponents = [
    {
      key: 1,
      title: "Individual Info",
      form: <PersonalDetails watch={watch} control={control} errors={errors} />,
    },
    {
      key: 2,
      title: "Contact Info",
      form: <ContactDetails watch={watch} control={control} errors={errors} />,
    },
    {
      key: 3,
      title: "Address Info",
      form: (
        <AddressDetails
          watch={watch}
          control={control}
          errors={errors}
          setValue={setValue}
        />
      ),
    },
    {
      key: 4,
      title: "Doctor Info",
      form: (
        <DoctorInfo control={control} errors={errors} setValue={setValue} />
      ),
    },
  ]

  const currentFormStepComponent = formStepComponents.find(
    (step) => step.key === formSteps
  )

  return (
    <>
      <FormNav
        title="Create Account"
        stepTitle={currentFormStepComponent.title}
        totalSteps={formStepComponents.length}
        formSteps={currentFormStepComponent.key}
        updateFormSteps={updateFormSteps}
      />
      <FormWrapper onSubmit={handleSubmit(onSubmit)}>
        {currentFormStepComponent.form}
      </FormWrapper>
    </>
  )
}
